export interface SseEvent {
  readonly type: string;
  readonly data: string;
}

export interface SseState {
  readonly pending: string;
  readonly afterCR: boolean;
  readonly type: string;
  readonly data: readonly string[];
}

export interface SseStep {
  readonly state: SseState;
  readonly events: readonly SseEvent[];
}

export const SSE_START: SseState = { pending: '', afterCR: false, type: '', data: [] };

const LINE_BREAK = /\r\n|\r|\n/;
const COMMENT = ':';
const DEFAULT_TYPE = 'message';
const LEADING_SPACE = ' ';

const fieldOf = (line: string): readonly [string, string] => {
  const colon = line.indexOf(':');
  if (colon === -1) return [line, ''];
  const value = line.slice(colon + 1);
  return [line.slice(0, colon), value.startsWith(LEADING_SPACE) ? value.slice(1) : value];
};

const withoutCRLFTail = (state: SseState, chunk: string): string =>
  state.afterCR && chunk.startsWith('\n') ? chunk.slice(1) : chunk;

export const parseSseChunk = (state: SseState, chunk: string): SseStep => {
  if (chunk === '') return { state, events: [] };
  const text = state.pending + withoutCRLFTail(state, chunk);
  const lines = text.split(LINE_BREAK);
  const pending = lines.pop() ?? '';
  const events: SseEvent[] = [];
  let { type, data } = state;
  for (const line of lines) {
    if (line === '') {
      if (data.length > 0) events.push({ type: type || DEFAULT_TYPE, data: data.join('\n') });
      type = '';
      data = [];
    } else if (!line.startsWith(COMMENT)) {
      const [field, value] = fieldOf(line);
      if (field === 'event') type = value;
      else if (field === 'data') data = [...data, value];
    }
  }
  return { state: { pending, afterCR: text.endsWith('\r'), type, data }, events };
};
